import { frameTypesAPI } from "@/views/Frames/Types/api";

export const getFrameOptions = async () => {
  try {
    const res = await frameTypesAPI.getList();
    return res?.data;
  } catch (e) {}
};